<template>
  <div class="d-flex align-center">
    <AppTooltip v-if="computedStatus && useTooltip" location="bottom">
      <template v-slot:activator="{ props }">
        <app-material-icon :name="computedStatus.icon"
                           :color="computedStatus.color"
                           :filled="computedStatus.filled"
                           :data-locator="`qa-status-icon-${status}`"
                           v-bind="props"
        />
      </template>
      <span>{{computedStatus.tooltip}}</span>
    </AppTooltip>
    <template v-else-if="computedStatus">
      <app-material-icon :name="computedStatus.icon"
                         :color="computedStatus.color"
                         :filled="computedStatus.filled"
                         :data-locator="`qa-status-icon-${status}`"
      />
    </template>
  </div>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'
import { QA_STATUS } from '@/common/utils/qa-status'

export default {
  name: 'QuestionAnswerStatusIcon',
  components: { AppTooltip },
  props: {
    status: {
      type: String,
      required: true,
    },
    useTooltip: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      QA_STATUS,
    }
  },
  computed: {
    computedStatus () {
      if (this.status === QA_STATUS.TO_ANSWER) {
        return {
          icon: 'schedule',
          filled: false,
          color: 'icon-warning',
          tooltip: this.$t('project.question-answer.QuestionAnswerStatusIcon.toAnswer'),
        }
      }

      if (this.status === QA_STATUS.TO_VALIDATE) {
        return {
          icon: 'hourglass_top',
          filled: false,
          color: 'icon-info',
          tooltip: this.$t('project.question-answer.QuestionAnswerStatusIcon.toValidate'),
        }
      }

      if (this.status === QA_STATUS.VALIDATED) {
        return {
          icon: 'check_circle',
          filled: true,
          color: 'icon-success',
          tooltip: this.$t('project.question-answer.QuestionAnswerStatusIcon.validated'),
        }
      }

      return null
    },
  },
}
</script>
